import { min } from 'lib/array/arrayUtils'

export function getLowestPricePackage(
  offer: App.HotelOffer | App.TourOffer | App.BundledOffer | App.HotelOfferSummary | App.TourOfferSummary | App.VillaOffer | App.BundleOffer,
  offerPackages: Array<App.HotelPackage>,
) {
  const defaultOptions = new Set(offer.defaultOptions)
  let packages = offerPackages.filter(x => defaultOptions.has(x.uniqueKey))
  packages = packages.length > 0 ? packages : offerPackages
  return min(packages, pkg => (pkg.memberPrice || pkg.price) + (pkg.surcharge ?? 0) || Number.MAX_SAFE_INTEGER)
}
